import { reactive } from "vue";

interface Settings {
  logo: string;
  showHelpBottomLinks: boolean;
  title: string;
  favicon: string;
  showExpireLinkInfoPanel: boolean;
  /**
   * Отключает тарифные ограничения
   */
  disable_tariff_feature: boolean;
}

function setup_settings(): Settings {
  if (import.meta.env.VITE_TARGET === 'veles') {
    return reactive({
      logo: new URL("@/assets/custom/veles/logo.svg", import.meta.url).href,
      showHelpBottomLinks: false,
      title: "ВелесЛинк: Видеозвонок",
      favicon: new URL("@/assets/custom/veles/Favicon.png", import.meta.url).href,
      showExpireLinkInfoPanel: false,
      disable_tariff_feature: true,
    });
  } else if(import.meta.env.VITE_TARGET === 'msr') {
    return reactive({
      logo: new URL("@/assets/custom/msr/logo.svg", import.meta.url).href,
      showHelpBottomLinks: false,
      title: "Коннект: Видеозвонок",
      favicon: new URL("@/assets/custom/msr/Favicon.png", import.meta.url).href,
      showExpireLinkInfoPanel: false,
      disable_tariff_feature: true,
    });
  } else if(import.meta.env.VITE_TARGET === 'connect-msr') {
    return reactive({
      logo: new URL("@/assets/custom/msr/logo.svg", import.meta.url).href,
      showHelpBottomLinks: false,
      title: "Коннект: Видеозвонок",
      favicon: new URL("@/assets/custom/msr/Favicon.png", import.meta.url).href,
      showExpireLinkInfoPanel: false,
      disable_tariff_feature: true,
    });
  } else {
    return reactive({
      logo: new URL("@/assets/custom/main/logo.svg", import.meta.url).href,
      showHelpBottomLinks: true,
      title: "Коннект: Видеозвонок",
      favicon: new URL("@/assets/custom/main/favicon.png", import.meta.url).href,
      showExpireLinkInfoPanel: true,
      disable_tariff_feature: false,
    });
  }
}

export const build_settings = setup_settings();
// title
document.title = build_settings.title;

//favicon
function setFavicon(url: string) {
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
}
// Выбор иконки по env
setFavicon(build_settings.favicon);
